import { autoserialize, inheritSerialization } from 'cerialize';
import { AbstractType } from './abstract-type';

@inheritSerialization(AbstractType)
export class TechnologyPlatform extends AbstractType {
  @autoserialize
  code: string;

  @autoserialize
  description: string;

  @autoserialize
  name: string;
}
